import { AlertModal } from '@modusign/design-system';

interface FieldCannotBeModifiedAlertModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

export default function FieldCannotBeModifiedAlertModal({
  isOpen,
  onConfirm,
}: FieldCannotBeModifiedAlertModalProps) {
  return (
    <AlertModal
      isOpen={isOpen}
      title="이용 안내"
      variant="warning"
      onClose={onConfirm}
      onRequestClose={onConfirm}
    >
      작은 화면에서는 입력란 확인만 가능합니다.
      <br />
      입력란 설정 변경은 PC에서 이용해 주세요.
    </AlertModal>
  );
}
